import React from 'react';
import logo from 'assets/images/logo-2-color.svg';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { authService } from 'services/api/auth';
import useAsyncFetch from 'hooks/async-fetch';
import PageLoader from 'components/Loaders/PageLoader';
import styles from './change-login-confirm-page.module.scss';

const ChangeLoginConfirmPage = () => {
  const [t] = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token');

  const [result, setResult] = React.useState<string | null>(null);

  const [handleConfirmEmail, loading] = useAsyncFetch({
    async asyncFunc() {
      await authService.changeLoginConfirm(token || '');
      setResult(t('auth.change_login_success'));
    },
    errorHandler: ({ errMessage }) => {
      setResult(errMessage);
    },
  });

  React.useEffect(() => {
    handleConfirmEmail();
  }, []);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className={styles.changeLoginConfirmPage}>
      <div className={styles.logo}>
        <img src={logo} width={200} height={80} alt="pro-data" />
      </div>
      {loading && <PageLoader />}
      {!loading && result && (
        <>
          <h1 className="font-heading mb-5">{result}</h1>
          <Link className="btn btn-outline-secondary" to="/" replace qa-element="back-to-main">{t('common.back_to_main')}</Link>
        </>
      )}
    </main>
  );
};

export default ChangeLoginConfirmPage;
